import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
//import SignInWithGoogleModal from "../SignInWithGoogle/SignInWithGoogleModal";
import { AiFillEye } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import x from "../../assets/images/X.png";
import branch from "branch-sdk";
import back from "../../assets/images/backarrow.svg";
import ar from "react-phone-input-2/lang/ar.json";
import {
  db,
  collection,
  onSnapshot,
  query,
  where,
  getFirebaseToken,
  updateDoc,
  orderBy,
  doc,
  getUserDataByCode,
  convertGlobalPrice,
  signOutUser,
  deleteDoc,
} from "../../utils/firebase/firebase.utils";
import {
  signInWithGoogle,
  createUserDocumentFromAuth,
  createUserWithEmailAndPassword,
  auth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  rmPhone,
  checkUsername,
  checkReferalCode,
  checkEmail,
  checkPhone,
  addReferral,
} from "../../utils/firebase/firebase.utils";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllUsers,
  IsGuest,
  SetJoinCoumminity,
} from "../../features/Products/ProductSlice";
import { GetBalances, SetReferralcode } from "../../features/Flags/FlagsSlice";
import { UserContext } from "../../context/user.context";
import VerifyUserModal from "../Modals/VerifyUserModal";
import toast from "react-hot-toast";
import VerifyMailResend from "../Modals/VerifyMailResend";
import { getFunctions, httpsCallable } from "firebase/functions";
import { SetAddresses } from "../../features/Addresses/AddressesSlice";
import { FillMybags } from "../../features/Bag/MybagSlice";
import { deleteUser, getAuth } from "firebase/auth";
import { writeBatch } from "firebase/firestore";
const functions = getFunctions();
function SignUp({ singupp, setSignUp, handleSignIn }) {
  const { t, i18n } = useTranslation();
  const [phoneNumber, setPhoneNumber] = useState();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const { constant } = useSelector((store) => store.flags);

  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [openModal, setModal] = useState(false);
  const [join, setJoin] = useState(false);
  const [eye, seteye] = useState(true);
  const [eye2, seteye2] = useState(true);
  const [password, setpassword] = useState("");
  const [password2, setpassword2] = useState("");
  const [verifyEmail, setVerifyEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showpassword, setShowpassword] = useState(false);
  const [showpassword2, setShowpassword2] = useState(false);
  const [type, settype] = useState(false);
  const [type2, settype2] = useState(false);
  const [termsConditions, setTermsConditions] = useState(false);
  const [subscribe, setSubscribe] = useState(false);
  const [isProvider, setIsProvider] = useState(false);
  const [isEmailExist, setIsEmailExist] = useState(false);
  const [isUsernameExist, setIsUsernameExist] = useState(false);
  const [isPhoneNumberExist, setIsPhoneNumberExist] = useState(false);
  const [showSignInWithGoolge, setShowSignInWithGoolge] = useState(false);
  const [joining, setJoining] = useState(false);
  // popup for verify User
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showResendModal, setShowResendModal] = useState(false);
  const { referralcode } = useSelector((store) => store?.flags);

  const dispatch = useDispatch();
  const { countryCode } = useSelector((store) => store.currency);
  // const [referralcodeuser, setReferralcodeuser] = useState([]);

  function handleSubscribe(event) {
    setSubscribe(!subscribe);
  }
  function handletermsConditions(event) {
    setTermsConditions(!termsConditions);
  }

  const handleContinueAsGuest = () => {
    // Event tracking script
    window.gtag("config", "AW-11517267669");
    window.gtag("event", "GetStartedWithGuest", {
      event_category: "Engagement",
      event_label: "Guest",
      value: 1,
    });
  };

  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  const SignInWithGoogle = async () => {
    setIsProvider(true);
    //await SignInUser();
    const { user } = await signInWithGoogle();
    if (user.uid != "no_user") {
      if (user.displayName) {
        var username = user.displayName.toLowerCase().replace(/\s/g, "");
        var existUsername = await checkUsername(username);
        // console.log("existUsername", existUsername);
        while (existUsername) {
          username = username + getRandomNumber(0, 1000);
          existUsername = await checkUsername(username);

          // console.log(username);
        }
      } else {
        var username = user?.email?.split("@")[0]?.toLowerCase();
        var existUsername = await checkUsername(username);
        while (existUsername) {
          username = username + getRandomNumber(0, 1000);
          existUsername = await checkUsername(username);

          console.log(username);
        }
      }

      const serDocref = await createUserDocumentFromAuth(user, {
        username: username,
        phone: !user?.phoneNumber ? "" : user?.phoneNumber,
      });
      handleSignIn(false);
    }
  };

  const SignIn = async () => {
    setLoading(true);

    const storedEmail = localStorage.getItem("signupEmail");

    // Case: SAME email - resume from where left off
    if (storedEmail === email) {
      await VerifyUser(email);
      setLoading(false);
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error(
        i18n.language === "ar"
          ? "!يرجى إدخال بريد إلكتروني صحيح"
          : "Please enter a valid email!"
      );
      setLoading(false);
      return;
    }

    if (password?.length < 6) {
      toast.error(
        i18n.language === "ar"
          ? "!كلمة المرور يجب أن تكون 6 أحرف على الأقل"
          : "Password must be at least 6 characters long!"
      );
      setLoading(false);
      return;
    }

    if (password !== password2) {
      toast.error(
        i18n.language === "ar"
          ? "!كلمات المرور غير متطابقة"
          : "Passwords do not match!"
      );
      setLoading(false);
      return;
    }

    // Check if email exists in Auth
    const existEmail = await checkEmail(email);
    if (existEmail) {
      toast.error("Email already exists");
      setLoading(false);
      return;
    }

    // If old user exists in Auth, delete them
    const auth = getAuth();
    const oldUser = auth.currentUser;
    // console.log(oldUser, "old user");
    if (oldUser && !oldUser.emailVerified) {
      const oldUid = oldUser.uid;
      // console.log(oldUid, "old user uid");

      try {
        // delete user from diff collections using cloud function
        const deleteUserCollections = httpsCallable(
          functions,
          "deleteUserOnCall"
        );
        await deleteUserCollections({ uid: oldUid });
        // Then delete the auth user
        await deleteUser(oldUser);
        console.log("Deleted old user and Firestore docs.");
      } catch (err) {
        console.error("Failed to delete old user:", err);
        // If document deletion failed, try deleting just the auth user
        try {
          await deleteUser(oldUser);
          console.log("Deleted auth user but Firestore docs remain");
          // delete user from diff collections using cloud function
          const deleteUserCollections = httpsCallable(
            functions,
            "deleteUserOnCall"
          );
          await deleteUserCollections({ uid: oldUid });
        } catch (authErr) {
          console.error("Failed to delete auth user:", authErr);
        }
      }
    }
    try {
      const { user } = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const userName = username?.toLowerCase();
      setUsername(userName);

      await createUserDocumentFromAuth(user, {
        username: userName,
        firstName,
        lastName,
        phone: "+" + phoneNumber,
      });

      const pendingUserData = {
        authUser: {
          uid: user?.uid,
          email: user?.email,
          emailVerified: user?.emailVerified,
        },
        userData: {
          username: userName,
          firstName,
          lastName,
          phone: "+" + phoneNumber,
          referralcode: referralcode || null,
        },
      };

      document.cookie = `pendingUser=${encodeURIComponent(
        JSON.stringify(pendingUserData)
      )}; path=/; max-age=${60 * 30}`;

      localStorage.setItem("signupEmail", email);
      localStorage.setItem("resendTimer", "60");

      // REMOVED the first VerifyUser call - only call once at the end
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        toast.error("Email already in use");
      } else {
        console.error("User creation failed:", error);
      }
      setLoading(false);
      return;
    }

    // Now proceed to verification flow (only called once)
    await VerifyUser(email);
    setLoading(false);
  };

  const VerifyUser = async (email) => {
    setVerifyEmail(email);

    try {
      const sendEmailVerification = httpsCallable(
        functions,
        "sendEmailVerification"
      );
      await sendEmailVerification({ email: email, userName: username });

      // toast.success("Verification email has been sent successfully.");
      setShowResendModal(true);

      setCurrentUser(null);
      dispatch(SetAddresses(null));
      dispatch(FillMybags([]));
      dispatch(GetBalances([]));

      setShowVerifyModal(false);
    } catch (error) {
      console.error("Verification error:", error);
      setCurrentUser(null);
      dispatch(SetAddresses(null));
      dispatch(FillMybags([]));
      dispatch(GetBalances([]));
      setShowVerifyModal(false);
      setShowResendModal(true);
      // Handle rate limiting specifically
      if (error.code === "auth/too-many-requests") {
        toast.error("Too many attempts. Please try again later.");
      }

      setLoading(false);
      setJoining(false);
      setCurrentUser(null);
      dispatch(SetAddresses(null));
      dispatch(FillMybags([]));
      dispatch(GetBalances([]));
    }
  };

  const resendEmail = async () => {
    //  Send data to cloud function
    const sendEmailVerification = httpsCallable(
      functions,
      "sendEmailVerification"
    );
    const response = await sendEmailVerification({
      email: email,
      userName: username,
    });
    toast.success("Email sended again successfully");
  };

  const [otp, setotp] = useState("");
  const [refrralcode, setRefrralCode] = useState("");
  const { currencies, selectedcurrency, currencydefault } = useSelector(
    (store) => store.currency
  );
  const [show, setshow] = useState(false);
  const [showVerify, setshowVerify] = useState(false);
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [verifyFailed, setVerifyFailed] = useState(false);
  const [final, setfinal] = useState("");
  const [referralerror, setReferralError] = useState("");
  // Sent OTP
  const sendOTP = async () => {
    if (phoneNumber === "" || phoneNumber.length < 9) return;
    const existEmail = await checkEmail(email);
    const existPhoneNumber = await checkPhone("+" + phoneNumber);
    var existReferralCode = true;
    // console.log("refrralcode", refrralcode);
    if (refrralcode != "") {
      existReferralCode = await checkReferalCode(refrralcode);
      dispatch(SetReferralcode(refrralcode));
      if (existReferralCode == false) {
        setReferralError(t("referralinputrequired"));
      } else {
        setReferralError("");
      }
    } else {
      dispatch(SetReferralcode(""));
    }
    if (!existEmail && !existPhoneNumber && existReferralCode) {
      let verify = new RecaptchaVerifier(
        "submit0",
        {
          size: "invisible",
        },
        auth
      );
      setSending(true);
      signInWithPhoneNumber(auth, "+" + phoneNumber, verify)
        .then((result) => {
          setfinal(result);
          // alert("code sent");
          setshowVerify(true);
          setshow(true);
          setSending(false);
        })
        .catch((err) => {
          alert(err);
          setSending(false);
          window.location.reload();
        });
    } else {
      if (existPhoneNumber) {
        setIsPhoneNumberExist(existPhoneNumber);
      }
      if (existEmail) {
        setIsEmailExist(existEmail);
      }
    }
  };

  // Validate OTP
  const ValidateOtp = () => {
    setVerifying(true);
    if (otp === null || final === null) return;
    setVerifying(true);
    final
      .confirm(otp)
      .then((result) => {
        //console.log(result.user.uid);
        rmPhone(result.user.uid);
        setVerifying(false);
        setshowVerify(false);
        setshowVerify(false);
        setVerifyFailed(false);
        setJoin(true);
        dispatch(SetJoinCoumminity(true));

        // success
      })
      .catch((err) => {
        //console.log(err);
        setVerifying(false);
        setVerifyFailed(true);
        alert("Wrong code");
      });
  };
  const NoOtp = async () => {
    console.log(username, "this is username to check");
    if (phoneNumber === "" || phoneNumber.length < 9) {
      toast.error("Please enter a valid phone number");
      return;
    }
    // check username exists
    const existUsername = await checkUsername(username?.toLowerCase());
    console.log(existUsername, "check user ha");
    const existEmail = await checkEmail(email);
    const existPhoneNumber = await checkPhone("+" + phoneNumber);

    if (existUsername) {
      // setIsUsernameExist(existUsername);
      toast.error("Username already exists");
      // setJoining(false);
      // setLoading(false);
      return;
    }
    var existReferralCode = true;
    // console.log("refrralcode", refrralcode);
    if (refrralcode != "") {
      existReferralCode = await checkReferalCode(refrralcode);
      dispatch(SetReferralcode(refrralcode));
      if (existReferralCode == false) {
        setReferralError(t("referralinputrequired"));
      } else {
        setReferralError("");
      }
    } else {
      dispatch(SetReferralcode(""));
    }
    //if (otp === null || final === null) return;

    if (!existEmail && !existPhoneNumber && existReferralCode) {
      setVerifying(false);
      setshowVerify(false);
      setshowVerify(false);
      setVerifyFailed(false);
      setJoin(true);
      dispatch(SetJoinCoumminity(true));
    } else {
      if (existPhoneNumber) {
        // setIsPhoneNumberExist(existPhoneNumber);
        toast.error("Phone number already exists");
      }
      if (existEmail) {
        setIsEmailExist(existEmail);
      }
    }
  };

  const Eye = () => {
    seteye(showpassword);
    settype(!showpassword);
    setShowpassword(!showpassword);
  };
  const Eye2 = () => {
    seteye2(showpassword2);
    settype2(!showpassword2);
    setShowpassword2(!showpassword2);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const customCountries = [
    { name: "Lebanon", iso2: "lb", dialCode: "961" },
    { name: "Dubai", iso2: "ae", dialCode: "971" },
    { name: "Saudi Arabia", iso2: "sa", dialCode: "966" },
  ];

  const customSortingFunction = (a, b) => {
    const customOrder = ["lb", "ae", "sa"];
    const aIndex = customOrder.indexOf(a.iso2);
    const bIndex = customOrder.indexOf(b.iso2);
    return aIndex - bIndex;
  };

  // Sort the customCountries array using the custom sorting function
  const sortedCountries = customCountries.slice().sort(customSortingFunction);
  // Set default UAE code if no phone number is set
  useEffect(() => {
    if (!phoneNumber) {
      setPhoneNumber("971"); // UAE country code
    }
  }, []);

  return (
    <>
      {showResendModal && (
        <VerifyMailResend
          email={email}
          show={showResendModal}
          setShow={setShowResendModal}
          VerifyUser={VerifyUser}
          verifyEmail={verifyEmail}
          resendEmail={resendEmail}
        />
      )}
      {showVerifyModal && (
        <VerifyUserModal
          prePopulatedEmail={email}
          show={showVerifyModal}
          setShow={setShowVerifyModal}
          VerifyUser={VerifyUser}
        />
      )}
      <div
        className={` row mx-md-2 mx-3 mt-3 montserrat-font ${!join ? `` : ``}`}
      >
        {!join ? (
          <>
            {/* sign up header */}
            <div
              className={` ${
                !showVerify ? "pt-3" : "pt-0"
              }    mx-md-0 pt-md-0 p-0 w-full text-center`}
              style={{
                fontSize: "14px",
                fontWeight: "400",
                color: "#262626",
                margin: "0 auto",
              }}
            >
              {t("signin1")}{" "}
              {convertGlobalPrice(
                "papAwH0XoKC3AmT9YmR7",
                100,
                !selectedcurrency ? currencydefault : selectedcurrency,
                currencies
              )}{" "}
              {currencies.length === 0
                ? null
                : !selectedcurrency
                ? i18n.language == "en"
                  ? currencies.filter(
                      (currency) => currency.id === currencydefault
                    )[0].name
                  : currencies.filter(
                      (currency) => currency.id === currencydefault
                    )[0].nameAr
                : i18n.language == "en"
                ? currencies.filter(
                    (currency) => currency.id === selectedcurrency
                  )[0].name
                : currencies.filter(
                    (currency) => currency.id === selectedcurrency
                  )[0].nameAr}{" "}
              {t("signin11")}
            </div>

            <form className="m-0 p-0 " onSubmit={handleSubmit}>
              <div
                className="row mx-0 "
                style={{
                  marginTop: "10px",
                }}
              >
                <div
                  className={`col px-0 ${
                    i18n.language == "en" ? `pe-md-2 pe-2` : `ps-md-2 ps-2 `
                  }`}
                >
                  <div className="mb-0 ">
                    <label
                      htmlFor="first"
                      className="form-label mb-0 "
                      style={{
                        fontSize: "13px",
                        color: "#262626",
                        fontWeight: "400",
                      }}
                    >
                      {t("First Name")}
                    </label>
                    {/* input field */}
                    <input
                      type="text"
                      placeholder={t("First Name")}
                      className={`form-control mt-1 ${
                        !showVerify ? `form-signup` : "form-signupotp"
                      }`}
                      id="firstName"
                      aria-describedby="emailHelp"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    {/* reuiqred aesterick */}
                    <div
                      id=""
                      className=" mt-1"
                      style={{
                        fontSize: "11px",
                        color: "#808080",
                        fontWeight: "400",
                      }}
                    >
                      {t("Required field")}
                    </div>
                  </div>
                </div>
                <div
                  className={`col px-0 ${
                    i18n.language == "en" ? `ps-md-2 ps-2` : `pe-md-2 pe-2 `
                  }`}
                >
                  <div className="mb-0">
                    <label
                      htmlFor="last"
                      className="form-label mb-0 "
                      style={{
                        fontSize: "13px",
                        color: "#262626",
                        fontWeight: "400",
                      }}
                    >
                      {t("Last Name")}
                    </label>
                    <input
                      type="text"
                      className={`form-control mt-1 ${
                        !showVerify ? `form-signup` : "form-signupotp"
                      }`}
                      id="lastName"
                      placeholder={t("Last Name")}
                      aria-describedby="emailHelp"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    {/* reuiqred aesterick */}
                    <div
                      id=""
                      className=" mt-1"
                      style={{
                        fontSize: "11px",
                        color: "#808080",
                        fontWeight: "400",
                      }}
                    >
                      {t("Required field")}
                    </div>
                  </div>
                </div>
              </div>

              {/* Username */}
              <div className="mb-0 mt-2">
                <label
                  htmlFor="username"
                  className="form-label mb-0"
                  style={{
                    fontSize: "13px",
                    color: "#262626",
                    fontWeight: "400",
                  }}
                >
                  {t("editprof3")}
                </label>
                <input
                  type="text"
                  className={`form-control mt-1 ${
                    !showVerify ? `form-signup` : "form-signupotp"
                  }`}
                  id="username"
                  value={username}
                  placeholder={t("Username")}
                  aria-describedby="emailHelp"
                  onChange={(e) => setUsername(e.target.value)}
                />
                <div
                  id="username"
                  className="mt-1"
                  style={{
                    color: isUsernameExist ? "red" : "#808080",
                    fontSize: "11px",
                    fontWeight: "400",
                  }}
                >
                  {isUsernameExist ? t("Already exists") : t("Required field")}
                </div>
              </div>
              <div className="mb-0 mt-2">
                <label
                  htmlFor="Phone-nbr"
                  className="form-label mb-0"
                  style={{
                    fontSize: "13px",
                    color: "#262626",
                    fontWeight: "400",
                  }}
                >
                  {t("Phone Number")}
                </label>
                <div className="row mx-0 mt-1">
                  <div className="col-12 px-0">
                    <PhoneInput
                      preferredCountries={["ae"]}
                      localization={i18n.language == "en" ? "" : ar}
                      country={countryCode.toLowerCase()}
                      countries={sortedCountries}
                      enableAreaCodes={true}
                      inputProps={{
                        name: "phone",
                        required: true,
                        autoFocus: false,
                      }}
                      value={phoneNumber}
                      onChange={setPhoneNumber}
                      className={`${
                        i18n.language == "ar" ? "phoneinput" : ""
                      } phone-input-custom`}
                    />
                  </div>
                </div>
                <div
                  id="emailHelp"
                  className="mt-1"
                  style={{
                    color: isPhoneNumberExist ? "red" : "#808080",
                    color: isEmailExist ? "red" : "#808080",
                    fontSize: "11px",
                    fontWeight: "400",
                  }}
                >
                  {isPhoneNumberExist
                    ? t("Already exists")
                    : t("Required field")}
                </div>
              </div>
              {constant == undefined ||
              constant.isReferralAvailable == undefined
                ? null
                : constant.isReferralAvailable == true && (
                    <div className="mb-0 mt-2">
                      <label
                        htmlFor="referral"
                        className="form-label mb-0"
                        style={{
                          fontSize: "13px",
                          color: "#262626",
                          fontWeight: "400",
                        }}
                      >
                        {t("referralinput")}
                      </label>
                      <div className="row mx-0 mt-1">
                        <div className="col-12 px-0">
                          <input
                            type="text"
                            className={`form-control  ${
                              !showVerify ? `form-signup` : "form-signupotp"
                            }`}
                            onChange={(e) => {
                              setRefrralCode(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div
                        id="emailHelp"
                        className="error-text"
                        style={{ color: referralerror ? "red" : "gray" }}
                      >
                        {referralerror != "" && t("referralinputrequired")}
                      </div>
                    </div>
                  )}

              {constant.isOtpEnabled ? (
                <div>
                  <div
                    className="mb-3"
                    style={{ display: show ? "block" : "none" }}
                  >
                    <label htmlFor="OTP" className="form-label emailLabel m-0">
                      {t("OTP")}
                    </label>
                    <input
                      type="text"
                      placeholder={t("Enter OTP")}
                      className="form-control form-email"
                      onChange={(e) => {
                        setotp(e.target.value);
                      }}
                    ></input>
                    <div
                      id="otpError"
                      className="error-text"
                      style={{ display: verifyFailed ? "block" : "none" }}
                    >
                      {t("Wrong Code")}
                    </div>
                  </div>
                  <div
                    className="row mx-0 h-100"
                    style={{ display: showVerify ? "block" : "none" }}
                  >
                    <div className="col-12 px-0 justify-content-center d-flex ">
                      <button
                        id="verifyOtp"
                        className={` ${
                          !showVerify
                            ? " btn-join-black-verify"
                            : `btn-join-black-verifyotp`
                        } w-100`}
                        disabled={otp.length !== 6}
                        onClick={verifying ? () => {} : ValidateOtp}
                      >
                        {verifying ? "Verifying..." : "Verify"}
                      </button>
                    </div>
                  </div>
                  <div className="row mx-0 h-100">
                    <div className="col-12 px-0 justify-content-center d-flex mt-2">
                      <button
                        //type="submit"
                        id="submit0"
                        className={
                          !show ? "btn-join-black w-100" : "btn-join w-100"
                        }
                        disabled={
                          !email || !phoneNumber || !firstName || !lastName
                        }
                        onClick={sendOTP}
                        style={{ display: !showVerify ? "block" : "none" }}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                          ></span>
                        ) : !show ? (
                          sending ? (
                            t("forget3")
                          ) : (
                            t("Send OTP")
                          )
                        ) : (
                          t("Join Community")
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                // first page signup btn
                <div className="row mx-0 h-100 mt-2">
                  <div className="col-12 px-0 justify-content-center d-flex mt-2">
                    <button
                      id="submit0"
                      className={
                        !show ? "btn-join-black w-100" : "btn-join w-100"
                      }
                      disabled={
                        !username ||
                        username?.length < 4 ||
                        phoneNumber?.length < 9 ||
                        !firstName ||
                        !lastName
                      }
                      onClick={NoOtp}
                      style={{ display: "block", borderRadius: "2px" }}
                    >
                      {verifying ? t("checking") : t("signup")}
                    </button>
                  </div>
                </div>
              )}
            </form>

            <div
              className={`d-flex align-items-center justify-content-center ${
                !showVerify ? `pt-md-2 pb-md-2` : `pt-md-0 pb-md-1`
              } p-0 text-center pt-2 pb-2`}
              style={{
                color: "#808080",
              }}
            >
              <hr
                className="flex-grow-1  "
                style={{
                  border: "1px solid #9A9A9A",
                }}
              />
              <span
                className="mx-2"
                style={{
                  fontSize: "14px",
                }}
              >
                {t("or")}
              </span>
              <hr
                className="flex-grow-1  "
                style={{
                  border: "1px solid #9A9A9A",
                }}
              />
            </div>

            <div className="d-flex justify-content-center p-0 ">
              <div
                className="w-100"
                onClick={() => branch.track("LoginWithGoogle")}
              >
                <button
                  className={` ${
                    !showVerify ? `btn-google ` : `btn-googleotp`
                  } `}
                  onClick={SignInWithGoogle}
                  style={{
                    backgroundColor: "#262626",
                    color: "white",
                    fontWeight: "400",
                    borderRadius: "2px",
                  }}
                >
                  <img
                    alt="main"
                    src="/googleicon.svg"
                    className={` fb ${
                      i18n.language == "en" ? "me-md-2 me-2" : "ms-md-2 ms-2"
                    }`}
                  />
                  {t("signin3")}
                </button>
              </div>
            </div>

            <div
              className={` ${
                !showVerify
                  ? constant != undefined &&
                    constant.isReferralAvailable == true
                    ? `pt-md-3`
                    : `pt-md-4 `
                  : `pt-md-2`
              } p-0 pt-4 mx-0`}
            >
              <div className=" text-center login-link px-0">
                <a
                  data-dismiss="modal"
                  className=" "
                  style={{
                    fontWeight: "400",
                    color: "#262626",
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleSignIn(false) &
                    handleContinueAsGuest() &
                    dispatch(IsGuest(true))
                  }
                >
                  {t("Continue as a guest")}
                </a>
              </div>
              <div
                className={`${
                  !showVerify ? `pt-md-1 ` : `pt-md-1`
                } row mb-1 pb-4 pb-md-0 pt-1 mx-0`}
                style={{
                  fontWeight: "400",
                  color: "#262626",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                <div className="col-12 text-center px-0 ">
                  <span className="learn-signup pb-md-0 ">
                    {t("By signing up  you accept our")}{" "}
                    <Link
                      className="learn-signup link "
                      to="/terms-and-conditions"
                      style={{ textDecoration: "underline" }}
                    >
                      {" "}
                      {t("Terms of Use")}
                    </Link>{" "}
                    {t("and")}{" "}
                    <Link
                      className="learn-signup link "
                      to="/privacy-policy"
                      style={{ textDecoration: "underline" }}
                    >
                      {t("PrivacyPolicy")}
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </>
        ) : (
          // page 2
          <div
            className="row mx-0 p-0"
            style={{
              position: "relative",
            }}
          >
            <div className="mx-0 p-0">
              <div className="" onClick={() => setJoin(false)}>
                <img
                  src={back}
                  alt="main"
                  style={{
                    height: "15px",
                    width: "15px",
                    cursor: "pointer",
                    position: "absolute",
                    top: "-10px",
                    left: "0",
                  }}
                />
              </div>
              <div className="col-12 px-0 pt-md-4 pt-3 detail-txt">
                {t("signup2")}
              </div>

              <div className="row mx-0 pt-md-4 pt-3">
                <div className="col-12 px-0">
                  <form className="px-md-2 p-0">
                    <div className="row mx-0 ">
                      <div className="col-12 px-0">
                        {/* email */}
                        <div className="mb-0 pt-md-3 ">
                          <label
                            htmlFor="username"
                            className="form-label emailLabel"
                          >
                            {t("Email address")}
                          </label>
                          <input
                            type="email"
                            className="form-control formlogin2"
                            id="email"
                            value={email}
                            onChange={(e) =>
                              setEmail(e.target.value.toLowerCase())
                            }
                            placeholder={t("Username")}
                            name="email"
                            aria-describedby="emailHelp"
                          />
                          <div
                            id="emailHelp"
                            className="error-text"
                            style={{ color: isEmailExist ? "red" : "#808080" }}
                          >
                            {isEmailExist
                              ? t("Already exists")
                              : t("Required field")}
                          </div>
                        </div>
                        <div className="mb-0 mt-2">
                          <label
                            htmlFor="password"
                            className="form-label emailLabel"
                          >
                            {t("Password")}
                          </label>
                          <div className="input-group">
                            <input
                              type={eye ? "password" : "text"}
                              required
                              className={` form-control  ${
                                i18n.language == "en"
                                  ? "formloginshow"
                                  : "formloginshowAr"
                              }`}
                              name="password"
                              placeholder={t("Password")}
                              value={password}
                              onChange={(e) => setpassword(e.target.value)}
                            />
                            <span
                              style={{ borderRadius: "0px" }}
                              className={`${
                                i18n.language == "en"
                                  ? "faform-loginshow"
                                  : "faform-loginshowAr"
                              } fa input-group-text ${
                                eye ? t("Show") : t("Hide")
                              }`}
                            >
                              <div
                                onClick={Eye}
                                className={`fa ${eye ? t("Show") : t("Hide")}`}
                              >
                                {eye ? t("Show") : t("Hide")}
                              </div>
                            </span>
                          </div>
                          <div id="emailHelp" className="form-text required">
                            {t("Required field")}
                          </div>
                        </div>
                        {/* confirm pass */}
                        <div className="mb-0 mt-2">
                          <label
                            htmlFor="password2"
                            className="form-label emailLabel"
                          >
                            {i18n.language === "en"
                              ? "Confirm Password"
                              : "تأكيد كلمة المرور"}
                          </label>

                          <div className="input-group">
                            <input
                              type={eye2 ? "password" : "text"}
                              required
                              className={` form-control  ${
                                i18n.language == "en"
                                  ? "formloginshow"
                                  : "formloginshowAr"
                              }`}
                              name="password2"
                              placeholder={
                                i18n.language === "en"
                                  ? "Confirm Password"
                                  : "تأكيد كلمة المرور"
                              }
                              value={password2}
                              onChange={(e) => setpassword2(e.target.value)}
                            />
                            <span
                              style={{ borderRadius: "0px" }}
                              className={`${
                                i18n.language == "en"
                                  ? "faform-loginshow"
                                  : "faform-loginshowAr"
                              } fa input-group-text ${
                                eye2 ? t("Show") : t("Hide")
                              }`}
                            >
                              <div
                                onClick={Eye2}
                                className={`fa ${eye2 ? t("Show") : t("Hide")}`}
                              >
                                {eye2 ? t("Show") : t("Hide")}
                              </div>
                            </span>
                          </div>
                          <div id="emailHelp" className="form-text required">
                            {t("Required field")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="row pt-5 pb-5 p-0    mx-0">
              <div className="col-12 px-0 mt-5">
                <button
                  type="submit"
                  className="btn-join p-0 mt-5"
                  disabled={termsConditions === true || loading}
                  onClick={SignIn}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></span>
                  ) : (
                    t("Join Community")
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default SignUp;
